<div class="root" (click)="onClick()">
    <div class="main">
        <div class="filename">
            {{message.Data?.FileName}}
        </div>
        <div class="ico" [ngClass]="{'me':message.IsMe}" [ngSwitch]="message.Data?.Extension">
            <img *ngSwitchDefault src="./assets/img/chat/file/extension/other.png">
            <img *ngSwitchCase="'.xls'" src="./assets/img/chat/file/extension/excel.png" /> 
            <img *ngSwitchCase="'.xlsx'" src="./assets/img/chat/file/extension/excel.png" /> 
            <img *ngSwitchCase="'.mp3'" src="./assets/img/chat/file/extension/music.png" /> 
            <img *ngSwitchCase="'.wav'" src="./assets/img/chat/file/extension/music.png" /> 
            <img *ngSwitchCase="'.ogg'" src="./assets/img/chat/file/extension/music.png" /> 
            <img *ngSwitchCase="'.pdf'" src="./assets/img/chat/file/extension/pdf.png" /> 
            <img *ngSwitchCase="'.ppt'" src="./assets/img/chat/file/extension/ppt.ppt" /> 
            <img *ngSwitchCase="'.rar'" src="./assets/img/chat/file/extension/rAR.png" />
            <img *ngSwitchCase="'.zip'" src="./assets/img/chat/file/extension/rAR.png" />
            <img *ngSwitchCase="'.7z'" src="./assets/img/chat/file/extension/rAR.png" />
            <img *ngSwitchCase="'.bz'" src="./assets/img/chat/file/extension/rAR.png" />
            <img *ngSwitchCase="'.txt'" src="./assets/img/chat/file/extension/txt.png" />
            <img *ngSwitchCase="'.doc'" src="./assets/img/chat/file/extension/word.png" />
            <img *ngSwitchCase="'.docx'" src="./assets/img/chat/file/extension/word.png" />
        </div>
        <div class="progress" [ngStyle]="{'visibility':message?.SendStatus==0?'visible':'hidden'}">
            <nz-progress [nzPercent]="message?.Progress" nzSize="small"></nz-progress>
        </div>
         
        <div class="file-info-text">{{message.Data?.FileSize|filesize}}</div>
    </div>
 
    <div class="foother">
        文件
    </div>
</div>